import React from "react";
import Dropbox from "../../../../../../components/svgs/Dropbox";
import SharePoint from "../../../../../../components/svgs/SharePoint";
import GoogleDrive from "../../../../../../components/svgs/GoogleDrive";
import { hasAllDataRepoPermission } from "../../../../../../utils";
import FilingAssistantMenu from "./FilingAssistantMenu";

export default function HeaderActions({
    tab,
    isFAMenuVisible,
    setFAMenuVisible,
    company,
    user,
    localModule,
    isDataRepository,
    syncing,
    syncApiBase,
    onConnectDataRoom,
    syncDrive,
    syncDropbox,
    reverseSyncDropbox,
    syncSharePoint,
    reSyncSharePoint,
    handleDisconnectDataRoom,
    onAccurateFileName,
    onAccurateFolderName,
    onClickFileReportHistory,
    onClickViewUnallocatedFiles,
    checkDuplicatedFiles,
    onClickDeduperReportHistory,
}) {
    if (tab === "kitemark") {
        return (
            <>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Kitemark Audit</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Kitemark Report</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Digital Certificate</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Full Report</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Report by Section</span>
            </>
        );
    }

    // For module tabs (non-repository), show a simplified Filing Assistant with import buttons
    if (localModule && !isDataRepository) {
        return (
            <div className="pr df jce aifs">
                <div className="menuHover pr h100">
                    <button onMouseEnter={() => setFAMenuVisible(true)} className="w200px btn-filing-assistant bg3 bg4-hover c1 td250 br50px px1rem py0-5rem h100 fw600 cp ttc bsbb tac df jcc aic fs13px">
                        Filing Assistant
                    </button>
                    <FilingAssistantMenu
                        company={company}
                        isVisible={isFAMenuVisible}
                        onAccurateFileName={onAccurateFileName}
                        onAccurateFolderName={onAccurateFolderName}
                        onClickFileReportHistory={onClickFileReportHistory}
                        onClickViewUnallocatedFiles={onClickViewUnallocatedFiles}
                        checkDuplicatedFiles={checkDuplicatedFiles}
                        onClickDeduperReportHistory={onClickDeduperReportHistory}
                    />
                </div>
            </div>
        );
    }

    if (!(localModule && isDataRepository)) return null;

    const syncLink = company.gDriveLink || company.sharePointLink || company.dropBoxLink;
    const allFiles = [];
    const sections = localModule?.sections ?? [];
    for (const sec of sections) {
        const questions = sec?.questions ?? [];
        for (const ques of questions) {
            const files = ques?.answer?.files ?? [];
            if (files.length > 0) allFiles.push(...files);
        }
    }

    let syncRequired = false;
    if (company.dropBoxFolderMetadata) {
        syncRequired = allFiles.some((file) => !file?.dbFileMetadata);
    }
    if (company.sharePointLink) {
        syncRequired = allFiles.some((file) => !file?.spDriveItem);
    }

    const disableSyncButton = syncRequired !== true;
    const isMember = company?.members?.some((member) => member._id === user._id);
    const hasAllPermissions = company ? hasAllDataRepoPermission(company?.memberPermissions?.[user._id]) : false;
    const isInvestorOwner = company?.investors && Object.keys(company.investors).length > 0 && company.investors[user._id] && hasAllDataRepoPermission(company?.investors?.[user._id]?.modules);
    const canManageDataRoom = ((!company?.isParent && company?.owners?.[0] === user._id) || (company?.isParent && company?.owners?.[0] === user._id) || ((company?.servicedBy?._id || company?.servicedBy) === user._id) || (isMember && hasAllPermissions) || isInvestorOwner);
    const openWindow = (url) => window.open(url, "_blank");

    return (
        <>
            {canManageDataRoom ? (
                <div className="pr menuHover1">
                    {/* Connect button — small outlined style with provider icons */}
                    {tab === "repository" && syncLink == undefined && (
                        <button
                            onClick={() => onConnectDataRoom(syncApiBase)}
                            className={`${!company.uploadedFile && "op20 pen "} cp fs13px fw600 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem mr0-5rem df jcc aic`}
                        >
                            Connect
                            <span className="df ml0-5rem">
                                <GoogleDrive className="pen fds w1rem ml0-5rem" />
                                <Dropbox className="pen fds w1rem ml0-5rem" />
                                <SharePoint className="pen fds w1rem ml0-5rem" />
                            </span>
                        </button>
                    )}
                </div>
            ) : (
                <div></div>
            )}

            {/* Three Dots Dropdown */}
            {tab === "repository" && (
                <div className="pr menuHover">
                    <button className="shadow cp bg1 br50px w2rem h2rem df jcc aic mr0-5rem">
                        <span class="fs1-5rem fw600 c3 mb1rem">...</span>
                    </button>
                    <div className="menu op0 pen zi10 bg1 br10px shadow pa r0 df fdc" style={{ minWidth: '220px' }}>
                        <div className="pr sub-menuHover">
                            <p className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb" style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                <img src={require('../../../../../../../images/filing-assistant-icon.png')} alt="filing-assistant-icon" />
                                Filing Assistant
                                <span className="c3 ml0-5rem">&gt;</span>
                            </p>
                            <div className="sub-menu op0 pen zi10 bg1 br10px shadow pa t0 df fdc" style={{ minWidth: '250px', left: '100%' }}>
                                <p onClick={onAccurateFileName} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb" style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>Import Files</p>
                                <p onClick={onAccurateFolderName} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb">Import Folders</p>
                                {(company.subscription && company.subscription.toLowerCase() === "pro") && <p onClick={onClickFileReportHistory} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb">Filing Assistant Manager</p>}
                                <p onClick={onClickViewUnallocatedFiles} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb">View Unallocated Files</p>
                                <p onClick={() => checkDuplicatedFiles()} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb">Deduper</p>
                                <p onClick={onClickDeduperReportHistory} className="w100 bg5-hover c14 px1rem py0-5rem cp df aic jcsb" style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>Deduper Reports</p>
                            </div>
                        </div>
                        <hr class="c16 fw100" />
                        {syncLink == undefined
                            ? <>
                                <p className="op50 df w100 bg5-hover c14 px1rem py0-5rem cna"><span className="df"><GoogleDrive className="pen fds w1rem mr0-5rem" /></span>Data Room</p>
                                <p className="op50 df aic w100 bg5-hover c14 px1rem py0-5rem cna"><img class="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room</p>
                            </>
                            : <>
                                {/* GoogleDrive */}
                                {company.gDriveLink && <>
                                    {company.folderId && (
                                        <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
                                            <button disabled={syncing} onClick={() => openWindow(`https://drive.google.com/drive/folders/${company.folderId}`)} class={`cp df ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                                <span className="df"><GoogleDrive className="pen fds w1rem mr0-5rem" /></span>Data Room
                                            </button>
                                        </p>
                                    )}
                                    <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
                                        <button disabled={syncing} onClick={() => syncDrive()} class={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                            <img class="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room
                                        </button>
                                    </p>
                                    <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
                                        <button disabled={syncing} onClick={() => handleDisconnectDataRoom("gdrive")} class={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                            <i class="fa fa-unlink c4 mr0-5rem" />Disconnect
                                        </button>
                                    </p>
                                </>}
                                {/* Dropbox */}
                                {company.dropBoxLink && <>
                                    {company.dropBoxFolderMetadata && (
                                        <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
                                            <button disabled={syncing} onClick={() => openWindow(`https://dropbox.com/home/${company.dropBoxFolderMetadata.path_display}`)} class={`cp df ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                                <span className="df"><Dropbox className="pen fds w1rem mr0-5rem" /></span>Data Room
                                            </button>
                                        </p>
                                    )}
                                    <p className={`${(company.syncRequired || syncRequired) ? 'op100' : 'op60'} cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`}>
                                        <button disabled={(syncing || disableSyncButton)} onClick={() => syncDropbox()} class={`${(company.syncRequired || syncRequired) ? 'op100' : 'op60'} cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                            <img class="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room
                                        </button>
                                    </p>
                                    <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`}>
                                        <button disabled={syncing || company.syncRequired || syncRequired} onClick={() => reverseSyncDropbox()} class={`cp df aic ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                            <img class="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Reverse Sync
                                        </button>
                                    </p>
                                    <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
                                        <button disabled={syncing} onClick={() => handleDisconnectDataRoom("dropbox")} class={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                            <i class="fa fa-unlink c4 mr0-5rem" />Disconnect
                                        </button>
                                    </p>
                                </>}
                                {/* SharePoint */}
                                {company.sharePointLink && <>
                                    {company.sharePointFolderDriveItem?.rootFolder?.webUrl && (
                                        <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
                                            <button disabled={syncing} onClick={() => openWindow(`${company.sharePointFolderDriveItem.rootFolder.webUrl}`)} class={`cp df ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                                <span className="df"><SharePoint className="pen fds w1rem mr0-5rem" /></span>Data Room
                                            </button>
                                        </p>
                                    )}
                                    <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`}>
                                        <button disabled={(syncing || disableSyncButton)} onClick={() => syncSharePoint()} class={`cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                            <img class="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Sync Data Room
                                        </button>
                                    </p>
                                    <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`}>
                                        <button disabled={syncing || company.syncRequired || syncRequired} onClick={() => reSyncSharePoint()} class={`cp df aic ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                            <img class="mr0-5rem" src={require('../../../../../../../images/sync-data-room.png')} alt="sync-data-room" />Reverse Sync
                                        </button>
                                    </p>
                                    <p className={`cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`}>
                                        <button disabled={syncing} onClick={() => handleDisconnectDataRoom("sharepoint")} class={`cp df aic ${syncing && 'op60 cnd'}`} style={{ background: 'transparent' }}>
                                            <i class="fa fa-unlink c4 mr0-5rem" />Disconnect
                                        </button>
                                    </p>
                                </>}
                            </>
                        }
                        <hr class="c16 fw100" />
                        <p className="df aic w100 bg5-hover c14 px1rem py0-5rem cp" style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                            <img src={require("../../../../../../../images/double-star-icon.png")} alt="double-star-icon" className="w20px h20px mr0-5rem" />
                            Analyse All
                        </p>
                    </div>
                </div>
            )}
        </>
    );
}
